import { Context } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 支付
export default async function orderQuery(context: Context, order_id: string): Promise<ApiResult> {
  const url = new URL('/mall/order/query', context.config.api.url);
  const { data: res } = await context.client.get(url.href, { params: { prepay_id: order_id } });
  return res;
}
